<script setup lang="ts">
import { services } from '.';

const text = 'Trénink & Adrenalin';
</script>

<template>
  <section
    class="bg-client-black gap-r12 xl:gap-r18 py-r12 lg:py-r18 flex flex-col"
  >
    <Marquee>
      <span class="text-client-white block leading-[100%] font-bold">
        {{ text }}
      </span>
    </Marquee>
    <PageContainerAlignment class="gap-r8 lg:pb-r18 flex flex-col">
      <ServicesExerciseCard
        v-for="(item, i) in services"
        :key="i"
        :service="item"
      />
    </PageContainerAlignment>
  </section>
</template>
